// Which build this page is running: the time the bundle was built (and the
// commit when the build host gives one), baked in by vite.config.ts as
// __APP_BUILD__. FaceLock Scan shows it small on the camera view and sends it
// with every telemetry event, so a screenshot or a log line says which version
// a phone is REALLY running (a phone still on a cached bundle looks exactly
// like a fix that "did not work"). "dev" in tests, where nothing is baked in.

declare const __APP_BUILD__: string | undefined;

export const BUILD_STAMP: string = typeof __APP_BUILD__ === "string" && __APP_BUILD__ ? __APP_BUILD__ : "dev";
